const enum SDCButtonSize {
  Default = 'default',
  Small = 'small',
}
export default SDCButtonSize;
